<script setup lang="ts">
import type { ImageProps } from '~/types';

defineProps<{ image: ImageProps }>();
</script>

<template>
  <img
    :src="image.url"
    :alt="image.alt"
    class="aspect-4/3 w-full object-cover transition-transform duration-300 ease-in-out sm:aspect-video lg:aspect-3/1 lg:group-hover/exercise-card:scale-105 lg:group-active/exercise-card:scale-110"
  />
  <div
    class="from-client-black/80 absolute inset-0 size-full bg-linear-to-t to-transparent"
  ></div>
</template>
